import React from 'react';
import Helmet from 'react-helmet';
import ContactView from '../components/ContactView';
import FooterView from '../components/FooterView';
import IndexFirstView from '../components/IndexFirstView';
import IndexSecondView from '../components/IndexSecondView';
import IndexThirdView from '../components/IndexThirdView';
import View from '../components/View';

const IndexPage = (props) => {
  const {
    data: {
      previewProjects,
      previewArticles,
    },
  } = props;
  return (
    <div>
      <Helmet
        meta={[
          {
            name: 'description',
            content: 'Depuis 2001, votre agence web avec un service de qualité pour tous vos projets web. Nous vous accompagnons dans la création de vos sites web vitrine, vos sites ecommerce et vos progiciels sur-mesures.',
          },
        ]}
      />
      <View colorMode="1">
        <IndexFirstView />
        <IndexSecondView data={previewProjects} />
        <IndexThirdView data={previewArticles} />
        <ContactView />
        <FooterView />
      </View>
    </div>

  );
};

export default IndexPage;

export const query = graphql`
fragment previewArticle on DatoCmsArticleConnection {
  totalCount,
  edges{
    node{
      id,
      title,
      subtitle,
      slug,
      pictures {
            id,
            sizes(maxWidth: 600, imgixParams: { fm: "jpg", auto: "compress" }){
              ...GatsbyDatoCmsSizes
            },
            alt
          }
    }
  }
}
  query ricococo {
    previewProjects: allDatoCmsArticle(limit: 3, sort: {fields:[publicationDate], order:DESC}, filter: {
      articleType: {eq: "project"}
    }) {
      ...previewArticle
    },
    previewArticles: allDatoCmsArticle(limit: 3, sort: {fields:[publicationDate], order:DESC}, filter: {
      articleType: {eq: "article"}
    }) {
      ...previewArticle
    }
  }
  `;



// WEBPACK FOOTER //
// ./src/pages/index.jsx